import {
  TokenizeRequestPayload,
  TokenizeResponsePayload,
} from "./tokenizeTypes";
import { fetcher } from "./utils";
import {
  CheckCvvRequestPayload,
  CheckCvvResponsePayload,
} from "./checkCvvTypes";

export const fetchToken = ({
  accessToken,
  ...payload
}: TokenizeRequestPayload) =>
  fetcher<TokenizeResponsePayload>("/tokenization-service/payment/token", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
    body: JSON.stringify(payload),
  });

export const fetchCheckCvv = ({
  accessToken,
  ...payload
}: CheckCvvRequestPayload) =>
  fetcher<CheckCvvResponsePayload>("/tokenization-service/payment/cvv", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
    body: JSON.stringify(payload),
  });
